<template>    
    <PageFull header="Адм. курсы" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <RatesList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import RatesList from '@/components/admin/RatesList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        RatesList,
        PageFull  
    },
}
</script>